var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconStorygamePlay = function SvgIconStorygamePlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 4.537c0-1.205 1.325-1.94 2.347-1.301l11.932 7.462a1.535 1.535 0 0 1 0 2.604L7.347 20.764C6.325 21.404 5 20.668 5 19.463V4.537Z",
    fill: "#fff",
    fillOpacity: 0.75
  })));
};
export default SvgIconStorygamePlay;